var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSuccess = function SvgSuccess(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 37,
    height: 36,
    fill: "none",
    viewBox: "0 0 37 36"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#2FD34A",
    d: "M14.307 16.43a1.86 1.86 0 0 0-2.602 0c-.743.707-.743 1.767 0 2.473l5.575 5.3c.371.354.743.53 1.3.53.558 0 .93-.176 1.301-.53L32.888 10.07c.557-.883.557-1.943-.372-2.473-.743-.53-1.858-.53-2.415.176L18.58 20.317z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#2FD34A",
    d: "M35.304 15.9c-1.115 0-1.858.707-1.858 1.767 0 7.773-6.69 14.133-14.865 14.133S3.716 25.44 3.716 17.667c0-3.71 1.487-7.244 4.274-9.894 2.787-2.826 6.503-4.24 10.59-4.24 1.116 0 2.417.177 3.531.354.93.353 2.044-.177 2.416-1.237s-.372-1.767-1.3-2.12h-.187A19.2 19.2 0 0 0 18.58 0C8.362 0 0 7.95 0 17.843c0 4.594 2.044 9.187 5.388 12.367 3.53 3.357 8.176 5.123 13.007 5.123 10.22 0 18.581-7.95 18.581-17.666.186-1.06-.743-1.767-1.672-1.767"
  })));
};
export default SvgSuccess;